import { render } from "./DropZone.vue?vue&type=template&id=73d460ce&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"

import "./DropZone.vue?vue&type=style&index=0&id=73d460ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d460ce"]])

export default __exports__